import { Drama, Clapperboard, PenLine, Palette, Camera, Users, Star, Mic, Music, Lightbulb, Megaphone, Sparkles, BookOpen, Crown } from "lucide-react";

export const ICONS = {
  drama: { icon: Drama, label: "أقنعة مسرح" },
  clapperboard: { icon: Clapperboard, label: "كلاكيت" },
  pen: { icon: PenLine, label: "قلم" },
  palette: { icon: Palette, label: "لوحة ألوان" },
  camera: { icon: Camera, label: "كاميرا" },
  users: { icon: Users, label: "أشخاص" },
  star: { icon: Star, label: "نجمة" },
  mic: { icon: Mic, label: "مايك" },
  music: { icon: Music, label: "موسيقى" },
  lightbulb: { icon: Lightbulb, label: "إضاءة" },
  megaphone: { icon: Megaphone, label: "مكبر صوت" },
  sparkles: { icon: Sparkles, label: "بريق" },
  book: { icon: BookOpen, label: "كتاب" },
  crown: { icon: Crown, label: "تاج" },
};

export const iconOf = (key) => (ICONS[key] || ICONS.star).icon;
